import { useState } from 'react';

interface FormState {
    [key:string]: string;
};

export const useForm = <T extends FormState>( initialStateForm: T) => {
  
    const [ formState, setFormState ] = useState( initialStateForm);

    const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormState({
            ...formState,
            [ name ]: value
        });
    }

    const onResetForm = () => {
        setFormState( initialStateForm );
    }

    return {
        onInputChange,
        onResetForm,
        ...formState,
    }
}